import { useUserState } from "../../../context/UserContext";
import {
  Card, CardActionArea, Tooltip,
  Grid
} from "@mui/material";
import Templateimg1 from "../../../assets/images/template1.png";
import Templateimg2 from "../../../assets/images/template2.png";
import Templateimg3 from "../../../assets/images/template3.png";
import Template1 from "../Template/FirstReport";
import Template2 from "../Template/SecondReport";
import Template3 from "../Template/ThirdReport";
import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import useStyles from "../styles";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";

const PROFILE_ENDPOINT = "/api/v1/profile";

const TermReportTemplate = ({ extraData, isMobile, onTemplatePreview, handleTemplateModal, templateModal }) => {
  const { profile, appLogo, subscription } = useUserState();
  const [selectedId, setSelectedId] = useState("template-1");
  const classes = useStyles();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [templateToConfirm, setTemplateToConfirm] = useState(null);
  const subscriptionName = subscription?.pricing_plan?.name;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (profile?.report_template?.template_id) {
      setSelectedId(profile.report_template.template_id);
    }
  }, [profile]);

  const reportData = {
    gender: "Female",
    class: { name: "Grade 5A" },
    session: { session: "2024/2025" },
    admission_date: "2024-09-01",
    class_population: "28",
    admission_no: "GWS/2024/0056",
    student_type: "Day Student",
    total_days: 90,
    days_present: 85,
    days_absent: 5,
    subjects: [
      {
        name: "Mathematics",
        scores: {
          CA_scores: { "CA 1": 18, "CA 2": 17, "CA 3": 19 },
          exam_score: 55,
          total: 89,
          class_highest_score: 95,
          class_lowest_score: 45,
          class_average_score: 78.5,
          grade: "A"
        }
      },
      {
        name: "English Language",
        scores: {
          CA_scores: { "CA 1": 16, "CA 2": 18, "CA 3": 17 },
          exam_score: 52,
          total: 85,
          class_highest_score: 92,
          class_lowest_score: 48,
          class_average_score: 75.2,
          grade: "B"
        }
      },
      {
        name: "Basic Science",
        scores: {
          CA_scores: { "CA 1": 17, "CA 2": 16, "CA 3": 18 },
          exam_score: 50,
          total: 82,
          class_highest_score: 88,
          class_lowest_score: 42,
          class_average_score: 72.8,
          grade: "B"
        }
      },
      {
        name: "Social Studies",
        scores: {
          CA_scores: { "CA 1": 15, "CA 2": 16, "CA 3": 17 },
          exam_score: 48,
          total: 79,
          class_highest_score: 85,
          class_lowest_score: 40,
          class_average_score: 70.1,
          grade: "C"
        }
      },
      {
        name: "Computer Studies",
        scores: {
          CA_scores: { "CA 1": 19, "CA 2": 18, "CA 3": 20 },
          exam_score: 58,
          total: 95,
          class_highest_score: 98,
          class_lowest_score: 50,
          class_average_score: 80.3,
          grade: "A+"
        }
      }
    ],
    extras: [
      {
        section_name: "Extracurricular Activities",
        section_type: "grade",
        section_value: {
          sports: "A",
          music: "B+",
          art: "A-",
          debate: "B"
        }
      },
      {
        section_name: "Social Skills",
        section_type: "score",
        section_value: {
          cooperation: "85%",
          communication: "78%",
          leadership: "90%",
          responsibility: "82%"
        }
      },
      {
        section_name: "Teacher's Comment",
        section_type: "text",
        section_value: "Emily has shown remarkable improvement this term. She is diligent."
      }
    ],
    display_pic: { file_url: null },
    class_teacher_signature: { file_url: null },
    admin_signature: { file_url: null },
    school_stamp: { file_url: null }
  };

  const obtainablescore = [
    {
      ca: [
        { ca_type: "CA 1", score: 20 },
        { ca_type: "CA 2", score: 20 },
        { ca_type: "CA 3", score: 20 }
      ]
    }
  ];

  const attendanceData = {
    total: 10,
    present: 10,
    absent: 30
  };

  const handleSelect = (template) => {
    if (!template.locked) {
      if (isMobile) {
        onTemplatePreview(template);
      } else {
        setTemplateToConfirm(template);
        setConfirmationModalOpen(true);
      }
    }
  };
  const templates = [
    {
      id: "template-1",
      name: "Template 1",
      version: "1.0",
      image: Templateimg1,
      locked: false,
      component: Template1
    },
    {
      id: "template-2",
      name: "Template 2",
      version: "1.0",
      image: Templateimg2,
      locked: !["Pro", "Partner", "Enterprise"].includes(subscriptionName),
      component: Template2
    },
    {
      id: "template-3",
      name: "Template 3",
      version: "1.0",
      image: Templateimg3,
      locked: !["Pro", "Partner", "Enterprise"].includes(subscriptionName),
      component: Template3
    }
  ];

  const confirmTemplateSelection = () => {
    if (templateToConfirm) {
      setSelectedId(templateToConfirm.id);
      setConfirmationModalOpen(false);

      const templateData = {
        report_template: {
          template_id: templateToConfirm.id,
          version: templateToConfirm.version
        }
      };

      setIsLoading(true);
      httprequest
        .patch(PROFILE_ENDPOINT, templateData)
        .then((res) => {
          toast.success(res?.data?.message || "Template updated successfully");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        })
        .catch((err) => {
          toast.error(err?.response?.message || "Failed to update template");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const currentTemplate = templates.find(t => t.id === selectedId)?.component || Template1;
  const comment = "This section can be used as a remark for a student";

  return (
    <Grid container spacing={4} className="margin-top-16">
      <Grid item lg={8} md={12} sm={12} xs={12}>
        {currentTemplate({
          profile,
          attendanceData,
          reportData,
          obtainablescore,
          comment,
          extraData,
          appLogo
        })}
      </Grid>
      {!isMobile && (
        <Grid item lg={4} md={12} sm={12} xs={12}>
          <div className="right-container relative-full container-border template-right">
            <div className={classes.container}>
              <h3 className={classes.templatetitle}>Templates</h3>

              <Grid container spacing={1}>
                {templates.map((template) => (
                  <Grid item lg={6} md={6} sm={12} xs={12} key={template?.id}>
                    <div className={classes.mycards}>
                      <Tooltip title={template.locked ? "Upgrade to unlock" : ""}>
                        <Card
                          className={`${classes.card} ${selectedId === template.id ? classes.activeCard : ""} ${
                            template.locked ? classes.lockedCard : ""
                          }`}
                          onClick={() => handleSelect(template)}
                        >
                          <CardActionArea disabled={template.locked}>
                            <img src={template?.image} alt={template?.name} className={classes.image} />
                          </CardActionArea>
                        </Card>
                        <p className={classes.templateName}>{template?.name}</p>
                      </Tooltip>
                    </div>
                  </Grid>
                ))}
              </Grid>

              <div className={classes.locknote}>
                <div>
                  <Icon icon="solar:info-circle-linear" />
                </div>
                <p> Access locked templates when you upgrade to a pro account.</p>
              </div>
            </div>
          </div>
        </Grid>
      )}

      <Modal
        title="Select Template"
        subtitle="Choose your preferred report template"
        modalContent={
          <div className={classes.templateModalContent}>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <div className="right-container relative-full container-border">
                <div className={classes.container}>
                  <h3 className={classes.templatetitle}>Templates</h3>

                  <Grid container spacing={1}>
                    {templates.map((template) => (
                      <Grid item lg={6} md={4} sm={6} xs={12} key={template?.id}>
                        <div className={classes.mycards}>
                          <Tooltip title={template.locked ? "Upgrade to unlock" : ""}>
                            <Card
                              className={`${classes.card} ${selectedId === template.id ? classes.activeCard : ""} ${
                                template.locked ? classes.lockedCard : ""
                              }`}
                              onClick={() => !template.locked && onTemplatePreview(template)}
                            >
                              <CardActionArea disabled={template.locked}>
                                <img src={template?.image} alt={template?.name} className={classes.image} />
                              </CardActionArea>
                            </Card>
                            <p className={classes.templateName}>{template?.name}</p>
                          </Tooltip>
                        </div>
                      </Grid>
                    ))}
                  </Grid>

                  <div className={classes.locknote}>
                    <div>
                      <Icon icon="solar:info-circle-linear" />
                    </div>
                    <p> Access locked templates when you upgrade to a pro account.</p>
                  </div>
                </div>
              </div>
            </Grid>
          </div>
        }
        isopen={templateModal}
        closeModal={handleTemplateModal}
      />

      <Modal
        title="Set Default Template"
        subtitle={
          templateToConfirm ? (
            <div>
              Are you sure you want to set
              <span className="modal-name-highlight"> {templateToConfirm.name} v{templateToConfirm.version}</span>
              as your default report template?
            </div>
          ) : null
        }
        modalContent={<></>}
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primaryoutline"
                buttonSize="full"
                color="btnfontprimary"
                buttonName="Cancel"
                onClick={() => setConfirmationModalOpen(false)}
              />
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName={isLoading ? "Setting..." : "Set as Default"}
                onClick={confirmTemplateSelection}
                disabled={isLoading}
              />

            </div>
          </>
        }
        isopen={confirmationModalOpen}
        closeModal={() => setConfirmationModalOpen(false)}
      />
    </Grid>);
};

export default TermReportTemplate;
